<a
  id="dashboard-appraisal-section"
  [routerLink]="APPRAISAL_NAME"
  title="'Tasación'"
  class="dashboard-card section-card"
  [ngClass]="{ disabled: status < minStatus.appraisal || isRejected }"
>
  <div class="dashboard-card__header">
    <h3 class="h-title">{{ 'appraisal_section_title' | translate }}</h3>
  </div>
  <div class="dashboard-card__body">
    <span class="ic ic-location"></span>

    @if (!httpError) {
      <div>
        @if (status <= minStatus.appraisal || !appraisalState?.appraisalAmount) {
          <h4 class="card-title">
            {{ 'appraisal_section_msg' | translate }}
          </h4>
        }
        @if (status > minStatus.appraisal && appraisalState?.appraisalAmount) {
          <h4 class="card-title">
            {{ 'Importe de la tasación' | translate }}
          </h4>
        }

        @if (status > minStatus.appraisal && appraisalState?.appraisalAmount) {
          <h4 class="card-title">{{ appraisalState?.appraisalAmount | number }} €</h4>
        }

        @if (status == minStatus.appraisal) {
          <div class="btn btn-02">{{ 'btn_continue_here' | translate }}</div>
        }

        <!-- introduciendo datos -->

        @if (status === minStatus.appraisal) {
          <h4 class="pd-b-10">
            {{ 'appraisal_section_btn_appraisal_pending' | translate }}
          </h4>
        }

        @if (status > minStatus.appraisal && !appraisalState?.appraisalDate) {
          <!-- cuando se manda la solucitud y no hay datos -->
          <h4 class="pd-b-10">
            {{ 'appraisal_section_btn_appraisal_send' | translate }}
          </h4>
        }

        @if (status > minStatus.appraisal && appraisalState?.appraisalDate) {
          <h4 class="pd-b-10">{{ 'Fecha de tasación' | translate }} {{ appraisalState?.appraisalDate | date }}</h4>
        }
      </div>
    } @else {
      <p class="has-error">{{ 'appraisal_section_msg_error' | translate }}</p>
    }
  </div>
  <div class="dashboard-card__footer"></div>
</a>
